import React from 'react'
import { Icon, ListItemIcon, Typography } from '@mui/material'
import { checkIconNumber } from '@app/helpers/myDevices/checkIconNumber'
import { devicesIcons } from '@app/lib/MyDevices/devicesIcons'
import withSelectDeviceConditionBehavior from '@app/hooks/withSelectDeviceConditionBehavior'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import { ITwrDeviceBackend, IZwaveDeviceBackend } from '@app/@types/scenes/scenesDevices'
import useStyles from './Device.style'

interface Props {
  deviceType: string,
  device: ITwrDeviceBackend | IZwaveDeviceBackend,
}
const Device: React.FC<Props> = (props) => {
  const {
    deviceType,
    device,
  } = props

  const { classes } = useStyles()
  const selectDevice = withSelectDeviceConditionBehavior(deviceType, device)

  return (
    <Wrapper
      className={classes.device}
      onClick={() => {
        selectDevice()
      }}
    >
      <ListItemIcon className={classes.iconWrapper}>
        <Icon fontSize="large" className={classes.icon}>{devicesIcons[checkIconNumber(device.icon)]}</Icon>
      </ListItemIcon>
      <Typography className={classes.title} variant="h6" component="h2">
        {device.name}
      </Typography>
    </Wrapper>
  )
}

export default Device
